/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { from, mergeMap } from 'rxjs';
import { inject } from '@angular/core';
import { EnvironmentService } from '../core/services/environment.service';
import { HeaderTokenService } from '@msi/commandcentral-user-authentication';

const BEARER_PREFIX = 'Bearer';
const DUAL_TOKEN_SERVICE_URL_PATTERN = /cc-admin-proxy/i;
const IDM_TOKEN_HEADER_NAME = 'IDM-Authorization';

export const dualTokenInterceptor = (req, next) => {
    const envService = inject(EnvironmentService);
    const requiresDualTokens = DUAL_TOKEN_SERVICE_URL_PATTERN.test(req.url) && !envService.environment.IS_CLOUD_ENVIRONMENT;

    if (!requiresDualTokens) {
        return next(req);
    }

    const headerTokenService = inject(HeaderTokenService);

    return from(headerTokenService.getToken()).pipe(
        mergeMap((idmToken) => {
            if (!idmToken) {
                return next(req);
            }
            return next(req.clone({
                setHeaders: { [IDM_TOKEN_HEADER_NAME]: `${BEARER_PREFIX} ${idmToken}` }
            }));
        })
    );
};
